export default __webpack_public_path__ + "static/media/photo--lg--31.0e6c7848.jpg";